var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2238 17.4548L46.3531 5.83337L53.079 17.484L26.2238 17.4548Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 20.4167C5.83337 19.6431 6.14066 18.9013 6.68765 18.3543C7.23463 17.8073 7.97649 17.5 8.75004 17.5H61.25C62.0236 17.5 62.7655 17.8073 63.3124 18.3543C63.8594 18.9013 64.1667 19.6431 64.1667 20.4167V61.25C64.1667 62.0235 63.8594 62.7654 63.3124 63.3124C62.7655 63.8594 62.0236 64.1667 61.25 64.1667H8.75004C7.97649 64.1667 7.23463 63.8594 6.68765 63.3124C6.14066 62.7654 5.83337 62.0235 5.83337 61.25V20.4167Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4063 48.1251H64.1667V33.5417H51.4063C47.1771 33.5417 43.75 36.807 43.75 40.8334C43.75 44.8599 47.1771 48.1251 51.4063 48.1251Z",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1667 24.0625V59.0625",
    stroke: "#5B4B86",
    strokeWidth: 5.83333,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic5);
export default __webpack_public_path__ + "static/media/pic5.a0d0bfc33cdbd3a66d4e573879ca0c7c.svg";
export { ForwardRef as ReactComponent };